<ng-container *ngIf="fondsPortfolioData$ | async as fondsPortfolioData">
  <div class="lv-uebersicht-portfolio">
<div class="lv-uebersicht-portfolio-section">
  <div class="lv-uebersicht-portfolio-section-titel-anlagestrategie">
    <ng-container *ngIf="fondsPortfolioData.isAnlagestrategieIndividuell">
      <div class="lv-uebersicht-portfolio-section-titel">Individuelles Portfolio</div>
    </ng-container>
    <ng-container *ngIf="fondsPortfolioData.isAnlagestrategieGemanaged">
      <div class="lv-uebersicht-portfolio-section-titel">{{ fondsPortfolioData.fondsgruppeNameInvestitionsbetrag }}</div>
    </ng-container>
    <div class="lv-uebersicht-fondsgruppe-details">
      <div class="lv-uebersicht-fondsgruppe-detail" *ngIf="!!fondsPortfolioData.artikelInvestitionsbetrag">
        Artikel {{ fondsPortfolioData.artikelInvestitionsbetrag }}
      </div>
      <div class="lv-uebersicht-fondsgruppe-detail">SRI {{ fondsPortfolioData.risikoklasseDurchschnittInvestitionsbetrag }}</div>
    </div>
  </div>
  <ng-container *ngIf="!!fondsPortfolioData.dataSourceInvestitionsbetrag?.data?.length">
    <lv-anlauf-ablauf-management-table class="lv-uebersicht-portfolio-table"
                                       matSortActive="name" matSortDirection="asc" matSort
                                       [isLastRowBold]="true"
                                       [dataSource]="fondsPortfolioData.dataSourceInvestitionsbetrag"></lv-anlauf-ablauf-management-table>
    <lv-donut-chart class="lv-uebersicht-portfolio-donut-chart" [data]="fondsPortfolioData.donutChartDataInvestitionsbetrag"
                    [url]="fondsPortfolioData.urlInvestitionsbetrag"></lv-donut-chart>
  </ng-container>
</div>
  </div>
</ng-container>
